/* import __COLOCATED_TEMPLATE__ from './saml-scim-settings-accordion.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class SamlScimSettingsAccordion extends Component {
  @service router;
  @tracked openSectionId;

  constructor(owner, args) {
    super(owner, args);
    let { section, subsection } = this.router.currentRoute?.queryParams ?? {};
    this.openSectionId = section === 'provisioning' ? 'PROVISIONING' : (section ?? null);

    if (subsection === 'exclude') {
      let attempts = 0;
      let tryScroll = () => {
        let element = document.querySelector('[data-intercom-target="exclude-title"]');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          element.classList.add('ring-2', 'ring-accent', 'rounded');
          setTimeout(() => element.classList.remove('ring-2', 'ring-accent', 'rounded'), 1200);
        } else if (attempts < 5) {
          attempts++;
          requestAnimationFrame(tryScroll);
        }
      };
      requestAnimationFrame(tryScroll);
    }
  }
}
